import * as React from 'react';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestDesktopList = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("ul", {
    ref: ref,
    role: "listbox",
    className: styles['list'],
    style: {
      maxHeight: props.maxHeight
    },
    "data-testid": "suggest-desktop-list",
    children: props.children
  });
});
SuggestDesktopList.displayName = 'SuggestDesktopList';